import styled from 'styled-components';
export const AvatarContainer = styled.div `
  overflow: hidden;
  font-size: ${({ size }) => `calc(${size}rem / 3)`};
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  min-width: ${({ size }) => size}rem;
  min-height: ${({ size }) => size}rem;
  width: ${({ size }) => size}rem;
  height: ${({ size }) => size}rem;
  color: ${({ theme }) => theme.colors.text.interactive};
  font-family: ${({ theme }) => theme.fonts.primaryBold};

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const ChangeImg = styled.button `
  position: absolute;
  border: none;
  background: none;

  bottom: 1.4rem;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 4.8rem;
  width: 4.8rem;
  padding: 0;
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: white;
  cursor: pointer;
`;
export const CustomImg = styled.img `
  width: 100%;
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  object-fit: cover;
`;
//# sourceMappingURL=styles.js.map